import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full px-6 py-8" }
const _hoisted_3 = { class: "space-y-8" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "flex items-center justify-between mb-8" }
const _hoisted_6 = { class: "text-lg font-semibold text-black" }
const _hoisted_7 = { class: "flex items-center gap-4" }
const _hoisted_8 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_9 = {
  key: 1,
  class: "text-center py-12"
}
const _hoisted_10 = {
  key: 2,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "mb-4 h-64 rounded-lg overflow-hidden border border-gray-200 bg-gray-200 flex items-center justify-center" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = {
  key: 1,
  class: "fas fa-image text-4xl text-gray-400"
}
const _hoisted_15 = { class: "mb-6" }
const _hoisted_16 = { class: "text-lg font-bold text-black mb-3" }
const _hoisted_17 = { class: "text-sm text-black leading-relaxed" }
const _hoisted_18 = { class: "text-2xl font-bold text-green-600 absolute bottom-6 left-6" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "bg-white border border-gray-200 rounded-xl p-8 shadow-lg" }
const _hoisted_21 = { class: "flex items-center justify-between mb-6" }
const _hoisted_22 = { class: "text-sm text-black" }
const _hoisted_23 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_24 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_25 = { class: "flex-1" }
const _hoisted_26 = { class: "font-semibold text-black text-sm" }
const _hoisted_27 = { class: "text-sm text-black" }
const _hoisted_28 = { class: "flex items-center space-x-3" }
const _hoisted_29 = { class: "flex items-center border border-gray-300 rounded-lg" }
const _hoisted_30 = ["onClick", "disabled"]
const _hoisted_31 = ["value", "onChange", "onBlur"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "text-right min-w-[80px]" }
const _hoisted_34 = { class: "text-sm font-semibold text-black" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "border-t-2 border-gray-200 pt-6 mt-6" }
const _hoisted_37 = { class: "flex justify-between items-center mb-6" }
const _hoisted_38 = { class: "text-2xl font-bold text-green-600" }
const _hoisted_39 = { class: "mt-12" }
const _hoisted_40 = {
  key: 0,
  class: "bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-center"
}
const _hoisted_41 = {
  key: 1,
  class: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"
}
const _hoisted_42 = { class: "bg-gray-50 rounded-lg p-4 mb-4" }
const _hoisted_43 = { class: "flex justify-between items-center mb-2" }
const _hoisted_44 = { class: "font-semibold" }
const _hoisted_45 = { class: "flex justify-between items-center" }
const _hoisted_46 = { class: "font-bold text-lg text-blue-600" }

import { ref, computed, onMounted } from 'vue'
import { 
  PageHeader, 
  BaseInput, 
  ReusableTable,
  ModalComp
} from '@/components'
import type { 
  PrestationProduct, 
  PrestationOrder, 
  PrestationApiResponse,
  VendeurPrestationApiResponse
} from '@/types/prestation'
import { useCartStore } from '@/stores/cart'
import { useAuthStore } from '@/stores/auth'
import { prestationsApi, commandesPrestationsApi } from '@/api'
import { getApiBaseUrl } from '@/config/api'
import { useNotification } from '@/composables/useNotification'
import {useRouter} from "vue-router";

// Stores

export default /*@__PURE__*/_defineComponent({
  __name: 'PrestationProductsView',
  setup(__props) {

const cartStore = useCartStore()
const authStore = useAuthStore()
const router = useRouter()
const { success, error } = useNotification()

// État réactif
const products = ref<PrestationProduct[]>([])
const orders = ref<PrestationOrder[]>([])
const loading = ref(false)
const showConfirmModal = ref(false)

const searchQuery = ref('')
const logoMenuImage = new URL('../../assets/images/Logo menu.jpg', import.meta.url).href
const sacImage = new URL('../../assets/images/Sac.jpg', import.meta.url).href
const bannerImage = new URL('../../assets/images/Banner.jpg', import.meta.url).href
const simpleImage = new URL('../../assets/images/simple.jpg', import.meta.url).href
const marqueADecouvrirImage = new URL('../../assets/images/marque-a-decouvrir.png', import.meta.url).href
const marqueEnVedetteImage = new URL('../../assets/images/marque-en-vedette.png', import.meta.url).href

// Colonnes pour le tableau des commandes
const orderColumns = [
  { key: 'date', title: 'Date', sortable: true, align: 'left' as const },
  { key: 'status', title: 'Statut', sortable: true, align: 'left' as const },
  { key: 'product', title: 'Produits', sortable: true, align: 'left' as const },
  { key: 'quantity', title: 'Quantité', sortable: true, align: 'right' as const },
  { key: 'totalPrice', title: 'Prix Total (€)', sortable: true, align: 'right' as const }
]

// Computed properties
const filteredProducts = computed(() => {
  if (!searchQuery.value) {
    return products.value
  }
  
  return products.value.filter(product =>
    product.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
    product.description.toLowerCase().includes(searchQuery.value.toLowerCase())
  )
})

const cartTotal = computed(() => cartStore.total)

const getPrestationImageByName = (name: string): string | null => {
  const normalized = String(name || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()

  if (normalized === 'marque a decouvrir') return marqueADecouvrirImage
  if (normalized === 'marque en vedette') return marqueEnVedetteImage
  if (normalized.includes('logo menu') || (normalized.includes('logo') && normalized.includes('menu'))) {
    return logoMenuImage
  }
  if (normalized.includes('sac')) return sacImage
  if (normalized.includes('banner') || normalized.includes('bannier') || normalized.includes('banniere')) {
    return bannerImage
  }
  if (normalized.includes('push email simple') || (normalized.includes('push') && normalized.includes('simple'))) {
    return simpleImage
  }
  return null
}

const getStatusLabel = (statut: number): 'En panier' | 'En attente' | 'Validé' | 'Annulé' | 'Inconnu' => {
  switch (statut) {
    case 0:
      return 'En panier'
    case 1:
      return 'En attente'
    case 2:
      return 'Validé'
    case 3:
      return 'Annulé'
    default:
      return 'Inconnu'
  }
}


// Méthodes
const loadData = async () => {
  loading.value = true
  try {
    // Vérifier l'authentification
    if (!authStore.isAuthenticated) {
      await authStore.checkAuth()
    }
    
    const prestationsData = await prestationsApi.getVisible()
    
    products.value = prestationsData.map((prestation: PrestationApiResponse) => ({
      id: parseInt(prestation.id_prestation.toString()),
      name: prestation.libelle,
      description: prestation.description || '',
      price: parseFloat(prestation.montant),
      image: prestation.imageUrl
        ? `${getApiBaseUrl()}${prestation.imageUrl}`
        : getPrestationImageByName(prestation.libelle) || undefined,
    }))
    
    if (!authStore.user?.id) {
      orders.value = []
      return
    }
    
    try {
      const commandesData = await commandesPrestationsApi.getCommandes(authStore.user.id)
      
      // Transformer les données API vers le format attendu
      orders.value = commandesData.map((commande: VendeurPrestationApiResponse) => ({
        id: commande.id_vendeur_prestation,
        date: commande.date_creation,
        status: getStatusLabel(commande.id_prestation_statut),
        product: commande.prestation?.libelle || commande.libelle,
        quantity: commande.quantite,
        totalPrice: parseFloat(commande.montant)
      }))
    } catch (err) {
      error('Erreur lors du chargement de l\'historique des commandes')
      orders.value = []
    }
    
  } catch (err) {
    products.value = []
  } finally {
    loading.value = false
  }
}

const addToCart = (product: PrestationProduct) => {
  cartStore.addItem(product)
}

const removeFromCart = (productId: number) => {
  cartStore.removeItem(productId)
}

const validateOrder = () => {
  showConfirmModal.value = true
}

const confirmOrder = async () => {
  if (!authStore.user?.id) {
    error('Erreur : Aucun vendeur connecté')
    return
  }

  if (cartStore.isEmpty) {
    error('Votre panier est vide')
    return
  }

  try {
    // Préparer les articles du panier pour l'envoi en DB
    const articles = cartStore.items.map(item => ({
      id_prestation: parseInt(item.id.toString()),
      quantite: item.quantity,
      montant: item.price * item.quantity,
      libelle: item.name
    }))

    await commandesPrestationsApi.creerCommande(authStore.user.id, articles)
    
    success(`Commande validée pour un total de ${cartTotal.value.toFixed(2)}€ HT`)
    
    cartStore.clearCart()
    
    await loadData()
    
  } catch (err) {
    error('Erreur lors de la validation de la commande. Veuillez réessayer.')
  }
}

onMounted(async () => {
  if (!authStore.isInitialized) {
    await authStore.checkAuth()
  }

  if (!authStore.isAuthenticated) {
    router.push({ name: 'auth' })
    return
  }
  await loadData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(PageHeader), {
        title: "Produits Prestation",
        subtitle: "Services et produits eFashion pour grossistes"
      }),
      _createElementVNode("div", _hoisted_2, [
        _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8\"><div class=\"text-blue-800 text-sm leading-relaxed\"><p class=\"mb-2\"><strong>Bienvenue sur la nouvelle page d&#39;achat de produits et service Efashion</strong> exclusivement réservée aux grossistes </p><p class=\"mb-2\"> Merci de trouver ci-dessous la liste des produits et services proposés. Pour commander, il suffit d&#39;ajouter au panier et de valider pour être livré dans la journée ou le lendemain directement par nos chauffeurs. </p><p class=\"mb-2\"> Les commandes seront automatiquement comptabilisées dans les prestations figurant dans votre facture de commission mensuelle. </p><p class=\"font-semibold\"> Tous les prix affichés sont hors taxes. </p></div></div>", 1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(filteredProducts.value.length) + " Produits ", 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(BaseInput), {
                  modelValue: searchQuery.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "Rechercher un produit...",
                  class: "pt-6 w-64"
                }, null, 8, ["modelValue"])
              ])
            ]),
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" }, null, -1),
                  _createElementVNode("p", { class: "mt-4 text-black" }, "Chargement des prestations...", -1)
                ])))
              : (filteredProducts.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[3] || (_cache[3] = [
                    _createElementVNode("div", { class: "bg-gray-50 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4" }, [
                      _createElementVNode("i", { class: "fas fa-box-open text-3xl text-black" })
                    ], -1),
                    _createElementVNode("p", { class: "text-black text-lg" }, "Aucune prestation disponible", -1),
                    _createElementVNode("p", { class: "text-black text-sm mt-2" }, "Veuillez réessayer plus tard", -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProducts.value, (product) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: product.id,
                        class: "bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-all duration-300 cursor-pointer transform hover:-translate-y-1 relative pb-16",
                        onClick: ($event: any) => (addToCart(product))
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          (product.image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: product.image,
                                alt: product.name,
                                class: "block w-full h-full object-cover object-center",
                                loading: "lazy"
                              }, null, 8, _hoisted_13))
                            : (_openBlock(), _createElementBlock("i", _hoisted_14))
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("h3", _hoisted_16, _toDisplayString(product.name), 1),
                          _createElementVNode("p", _hoisted_17, _toDisplayString(product.description), 1)
                        ]),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(product.price.toFixed(2)) + "€ ", 1),
                        _createElementVNode("button", {
                          class: "px-6 py-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-300 text-sm font-medium shadow-md hover:shadow-lg transform hover:scale-105 absolute bottom-6 right-6",
                          onClick: _withModifiers(($event: any) => (addToCart(product)), ["stop"])
                        }, _cache[4] || (_cache[4] = [
                          _createElementVNode("i", { class: "fas fa-cart-plus mr-2" }, null, -1),
                          _createTextVNode(" Ajouter ")
                        ]), 8, _hoisted_19)
                      ], 8, _hoisted_11))
                    }), 128))
                  ]))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-xl font-bold text-black" }, [
                _createElementVNode("i", { class: "fas fa-shopping-cart mr-3 text-blue-600" }),
                _createTextVNode(" Mon Panier ")
              ], -1)),
              _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(cartStore).itemCount) + " article" + _toDisplayString(_unref(cartStore).itemCount > 1 ? 's' : ''), 1)
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "border-b border-gray-200 mb-6" }, null, -1)),
            (_unref(cartStore).isEmpty)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[6] || (_cache[6] = [
                  _createElementVNode("div", { class: "bg-gray-50 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4" }, [
                    _createElementVNode("i", { class: "fas fa-shopping-cart text-3xl text-black" })
                  ], -1),
                  _createElementVNode("p", { class: "text-black text-lg" }, "Votre panier est vide", -1),
                  _createElementVNode("p", { class: "text-black text-sm mt-2" }, "Ajoutez des produits pour commencer", -1)
                ])))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cartStore).items, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "flex items-center justify-between p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg border border-gray-200"
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("h4", _hoisted_26, _toDisplayString(item.name), 1),
                        _createElementVNode("p", _hoisted_27, _toDisplayString(item.price.toFixed(2)) + "€ HT", 1)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_unref(cartStore).setQuantity(item.id, item.quantity - 1)),
                            class: "px-3 py-1 text-black hover:text-black hover:bg-gray-100 transition-colors",
                            disabled: item.quantity <= 1
                          }, _cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "fas fa-minus text-xs" }, null, -1)
                          ]), 8, _hoisted_30),
                          _createElementVNode("input", {
                            value: item.quantity,
                            onChange: ($event: any) => (_unref(cartStore).setQuantity(item.id, parseInt(($event.target as HTMLInputElement)?.value) || 1)),
                            onBlur: ($event: any) => (_unref(cartStore).setQuantity(item.id, parseInt(($event.target as HTMLInputElement)?.value) || 1)),
                            class: "w-12 text-center py-1 border-0 focus:ring-0 text-sm font-medium",
                            type: "number",
                            min: "1",
                            max: "99"
                          }, null, 40, _hoisted_31),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_unref(cartStore).setQuantity(item.id, item.quantity + 1)),
                            class: "px-3 py-1 text-black hover:text-black hover:bg-gray-100 transition-colors"
                          }, _cache[8] || (_cache[8] = [
                            _createElementVNode("i", { class: "fas fa-plus text-xs" }, null, -1)
                          ]), 8, _hoisted_32)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("p", _hoisted_34, _toDisplayString((item.price * item.quantity).toFixed(2)) + "€ ", 1)
                        ]),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (removeFromCart(item.id)),
                          class: "text-red-500 hover:text-red-700 p-2 rounded-full hover:bg-red-50 transition-colors ml-2"
                        }, _cache[9] || (_cache[9] = [
                          _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                        ]), 8, _hoisted_35)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-lg font-semibold text-black" }, "Total HT:", -1)),
                      _createElementVNode("span", _hoisted_38, _toDisplayString(cartTotal.value.toFixed(2)) + "€", 1)
                    ]),
                    _createElementVNode("button", {
                      onClick: validateOrder,
                      class: "w-full bg-gradient-to-r from-green-600 to-green-700 text-white py-3 rounded-lg hover:from-green-700 hover:to-green-800 transition-all duration-300 font-semibold text-base shadow-lg hover:shadow-xl transform hover:scale-105"
                    }, _cache[11] || (_cache[11] = [
                      _createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1),
                      _createTextVNode(" Valider la commande ")
                    ]))
                  ])
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-xl font-semibold text-black mb-6" }, " Historique des produits commandés ", -1)),
          (orders.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, _cache[13] || (_cache[13] = [
                _createElementVNode("div", { class: "bg-gray-50 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4" }, [
                  _createElementVNode("i", { class: "fas fa-shopping-bag text-3xl text-black" })
                ], -1),
                _createElementVNode("p", { class: "text-black text-lg" }, "Aucune commande trouvée", -1),
                _createElementVNode("p", { class: "text-black text-sm mt-2" }, "Vos commandes de prestations apparaîtront ici", -1)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createVNode(_unref(ReusableTable), {
                  columns: orderColumns,
                  data: orders.value,
                  sortable: true
                }, null, 8, ["data"])
              ]))
        ])
      ])
    ]),
    _createVNode(_unref(ModalComp), {
      isVisible: showConfirmModal.value,
      "onUpdate:isVisible": _cache[1] || (_cache[1] = ($event: any) => ((showConfirmModal).value = $event)),
      title: "Confirmer la commande",
      alert: "Êtes-vous sûr de vouloir valider cette commande ?",
      cancelText: "Annuler",
      confirmText: "Confirmer",
      size: "sm",
      onConfirm: confirmOrder
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-sm text-black" }, "Articles :", -1)),
            _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(cartStore).itemCount), 1)
          ]),
          _createElementVNode("div", _hoisted_45, [
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-sm text-black" }, "Total :", -1)),
            _createElementVNode("span", _hoisted_46, _toDisplayString(cartTotal.value.toFixed(2)) + "€ HT", 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["isVisible"])
  ], 64))
}
}

})